/**
 * "Gövde Ön Stok Yönetimi" sekmesi — rapordaki dördüncü sayfa.
 *
 * Sayfa süzgeci `govde_and_govde_on = "Gövde Ön"` (api.js → `#govde-on`).
 * Üstte tanım bazında stok tablosu, altta tam genişlikte F14 / F23 stok
 * eğrileri. Slicer'lar: Malzeme, Renk.
 */
import { PROD_PATH } from "../api";
import { BLUE, ORANGE } from "../theme";
import {
  BREAKPOINTS,
  slicer,
  tabloKarti,
  temizle,
  tvSecici,
  yiginYerlesim,
  zamanEkseni,
} from "./ortak";

export const GOVDE_ON_STOK_ROWS = 24;

const LAYOUTS = yiginYerlesim([
  ["temizle", 2],
  ["f-malzeme", 6],
  ["f-renk", 3],
  ["stok-tablosu", 12],
  ["on-stok", 9],
]);

export function buildGovdeOnStokConfig(rowPx, gap, refreshKey = 0, tvMode = false) {
  const V = tvSecici(tvMode);
  const GOVDE_ON = { url: `${PROD_PATH}?_t=${refreshKey}#govde-on` };

  return {
    layout: { columns: 24, rowHeight: rowPx, gap, breakpoints: BREAKPOINTS },

    filters: [
      // Sol sütundaki logo kaldırıldı; boşalan 2 satırı Malzeme listesi aldı.
      temizle({ x: 0, y: 0, w: 3, h: 2 }, LAYOUTS),
      slicer("f-malzeme", "product", "Malzeme", { x: 0, y: 2, w: 3, h: 8 }, LAYOUTS, {
        selectAll: true,
      }),
      slicer("f-renk", "color", "Renk", { x: 0, y: 10, w: 3, h: 4 }, LAYOUTS),
    ],

    tiles: [
      tabloKarti(
        "stok-tablosu",
        null,
        GOVDE_ON,
        [
          { key: "order_nr", label: "Order Number", align: "center" },
          { key: "tarih", label: "Tarih" },
          { key: "saat", label: "Saat" },
          // Aynı tanımı paylaşan malzemelerin kodları yan yana (raporda
          // toplamları basılıyordu).
          { key: "product", label: "Malzeme", agg: "join", wrap: true },
          { key: "tanim", label: "Tanım" },
          { key: "color", label: "Renk" },
          { key: "F", label: "F14 / F23" },
          { key: "inventory", label: "Stok", agg: "sum", format: "int" },
        ],
        { x: 3, y: 0, w: 21, h: 14 },
        LAYOUTS,
        V,
        {
          groupBy: ["tarih", "saat", "tanim", "color", "F", "order_nr"],
          cellStyle: { size: V(16, 13) },
          headerStyle: { size: V(17, 14) },
        }
      ),

      {
        id: "on-stok",
        source: GOVDE_ON,
        layout: { x: 0, y: 14, w: 24, h: 10 },
        layouts: LAYOUTS["on-stok"],
        chart: {
          type: "line",
          title: "Zamana göre Gövde Ön Stok",
          dimensions: ["zaman", "tarih"],
          // Rapordaki seri sütunu `F` (Gövde Ön Tipi); seri başına sütun
          // api.js'te açılıyor.
          measures: [
            { key: "on_f14", label: "F14", color: ORANGE },
            { key: "on_f23", label: "F23", color: BLUE },
          ],
          options: {
            ...zamanEkseni(V),
            className: "pano-on-stok",
          },
        },
      },
    ],
  };
}
